module.exports = __webpack_public_path__ + "img/118D-6.29.b4f86682.png";